import { render, staticRenderFns } from "./EditTitleDialog.vue?vue&type=template&id=789c3a16"
import script from "./EditTitleDialog.vue?vue&type=script&lang=js"
export * from "./EditTitleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports